import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import MoreHorizontalIcon from '../../../icons/more-horizontal.svg'

function EmailShowConversationButton(props) {
  const { t } = useTranslation()

  return (
    <Button.Contained
      {...props}
      isGrey
      beforeIconProps={{ Icon: MoreHorizontalIcon }}
      height={BUTTON_HEIGHT_32}
      tooltip={t('Email.ShowConversationButtonTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default EmailShowConversationButton
